import axios from "axios";

const authClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: null,
  },
});

export async function requestMicrosoftAuthLink(): Promise<string> {
  const response = await authClient.post("/auth/get_request_auth_link", {
    provider: "microsoft",
  });
  if (typeof response?.data !== "string" || !response.data.trim()) {
    throw new Error("The authorization response did not contain a URL.");
  }
  const authUrl = new URL(response.data);
  if (authUrl.protocol !== "https:" && authUrl.protocol !== "http:") {
    throw new Error("The authorization URL is invalid.");
  }
  return response.data;
}
